import { AxiosResponse } from "axios";
import { App, AppDetails,ShopifyConnect,WoocommerceConnect } from "./appStore.slice"; // Adjust the path as necessary
import { coreAxios } from "../../../Utils";
import { getHttpService } from "../../../Services";
import { APPSTORE_ENDPOINTS } from "../../../Services/Apis/Endpoints";
export class CoreService {
  static httpService = getHttpService(coreAxios);
  static getAvailableApps = (payload:any): Promise<
    AxiosResponse<{ data: App[]; status: boolean }>
  > => {
    const { query, installed } = payload;
  
    // Construct the query parameters in one variable
    const queryParams = new URLSearchParams();
    
    if (installed) {
      queryParams.append('installed', installed);
    }
  
    if (query) {
      queryParams.append('query', query);
    }
  
    // Convert the queryParams object to a string and append to the URL
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
  
    return CoreService.httpService.get({
      url: `${APPSTORE_ENDPOINTS.AVAILABLE_APPS}${queryString}`,
    });
  };
  static getInstalledApps = (): Promise<
    AxiosResponse<{ data: App[]; status: boolean }>
  > => {
    return CoreService.httpService.get({
      url: `${APPSTORE_ENDPOINTS.AVAILABLE_APPS}?installed=true`,
    });
  };
  static getAppDetails = (
    id: string
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    return CoreService.httpService.get({
      url: `${APPSTORE_ENDPOINTS.APP_DETAILS}/${id}`,
    });
  };
  // ************** Woocommerce apis *******************
  static postConnectWoocommerceApp = (
    data: any
  ): Promise<AxiosResponse<{ data: WoocommerceConnect; status: boolean }>> => {
    return CoreService.httpService.post({
      url: `${APPSTORE_ENDPOINTS.WOOCOMMERCE_CONNECT}`,data
    });
  };
  
  // ************** Shopify apis *******************
  static postConnectShopifyApp = (
    data: any
  ): Promise<AxiosResponse<{ data: ShopifyConnect; status: boolean }>> => {
    return CoreService.httpService.post({
      url: `${APPSTORE_ENDPOINTS.SHOPIFY_CONNECT}`,data
    });
  };
  static postConnectShopifyAppManually = (
    data: any
  ): Promise<AxiosResponse<{ data: ShopifyConnect; status: boolean }>> => {
    return CoreService.httpService.post({
      url: `${APPSTORE_ENDPOINTS.SHOPIFY_CONNECT_MANUAL}`,data
    });
  };
  //****************************************************
}